import React from 'react';
import { Button, Icon, Toast, } from 'antd-mobile';

import './index.less';

class serviceAgreenmentText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        return (
            <div className="serviceAgreenmentTextBox">
                <div style={{overflow:'hidden'}}>
                    <div style={{height:'100%', overflowY: 'auto'}}>
                        <div className="page_type_h5">
                            <article>
                                <h2>绿色慧联用户协议</h2>
                                <h3>提示条款</h3>
                                <section>
                                    欢迎您使用绿色慧联提供的产品和服务（下称“服务”）
                                </section>
                                <section>
                                    本协议自发布之日起即刻生效。本协议各条款前“【】”所列索引关键词仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您自身权益，建议您仔细阅读各条款具体表述。
                                </section>
                                <section>
                                    【审慎阅读】您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。
                                    <b>
                                        请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。
                                    </b>
                                    如您对协议有任何疑问，可向绿色慧联客服致电咨询。
                                </section>
                                <section>
                                    【签约动作】当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与绿色慧联达成一致，成为绿色慧联“用户”。
                                    <b>
                                        阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。
                                    </b>
                                </section>
                                <section>
                                    <h3>一、协议范围</h3>
                                    <p>
                                        <b>1.1</b>
                                        本协议由您与浙江绿色慧联有限公司（下称“绿色慧联”）共同缔结，本协议对您与绿色慧联均具有合同效力，本协议适用于网页端、移动客户端（包括IOS、安卓及已有或未来将新增的任何其他移动客户端）等各类平台或媒介中绿色慧联所提供的各项服务。您知悉并理解，为享受上述相关服务，您必须自行提供相关上网设备（如：个人电脑、手机、平板电脑或其他设备）并自行负担相关网络使用和商品服务支付所产生的有关费用。
                                    </p>
                                    <p>
                                        <b>1.2</b>
                                        绿色慧联在不同地区拥有子公司和/或关联法律实体。在某些时候，这些子公司和/或关联法律实体将代表绿色慧联向您提供服务。您理解并同意这些子公司和/或关联法律实体有权向您提供服务。
                                    </p>
                                    <p>
                                        <b>1.3</b>
                                        【主体变更】
                                        <b>
                                            绿色慧联可能根据业务调整将本协议项下权利义务转让给第三方。绿色慧联完成前述转让后，权利义务受让方会与您共同履行本协议并向您提供服务，这种情况不会影响您本协议项下权益。
                                        </b>
                                    </p>
                                    <p>
                                        <b>1.4</b>
                                        【补充协议】您理解并同意，您与绿色慧联签署的本协议列明的条款并不能完整罗列并覆盖您与绿色慧联所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，
                                        <b>
                                            绿色慧联有时还会适用一些协议或附加条款或服务要求（包括年龄要求和资质要求），该协议或附加条款或服务要求将会与相关服务一同提供，并成为本协议的补充协议，与本协议不可分割且具有同等法律效力。如果您使用绿色慧联服务，视为您同意上述补充协议。如果补充协议与本协议有冲突，以补充协议为准。
                                        </b>
                                    </p>
                                </section>
                                <section>
                                    <h3>二、用户注册</h3>
                                    <p>
                                        <b>2.1</b>
                                        【账户取得】您理解并同意，为了使用绿色慧联服务，您可能需要一个账户。当您根据绿色慧联注册页面提示点击协议正本下方的“确认”按钮接受或同意本协议，并按照本产品规定的注册程序填写账户信息（包括您的姓名/企业名称、电子邮件地址、联系电话、联系地址等），设置或确认账户名称（包括用户名、邮箱、手机号码等）和账户密码，当您完成全部注册程序，即表示您已经阅读、理解并接受本协议的全部条款及各类规则。
                                    </p>
                                    <p>
                                        <b>2.2</b>
                                        您确认，在您取得账户或使用绿色慧联服务前，您应具备法律规定相应资格及民事行为能力。
                                        <b>
                                            如果您不具备，请您应立即停止注册或停止使用绿色慧联服务，否则您应依据法律规定承担因此导致的一切后果。
                                        </b>
                                    </p>
                                    <p>
                                        <b>2.3</b>
                                        <b>
                                            如果您属于非自然人法律主体，则您确认，在您取得绿色慧联账户或使用绿色慧联服务前，您为合法设立并已具备相应资质开展经营活动或其他业务的法人或其他组织。如果不具备前述条件的，您应立即停止注册或停止使用绿色慧联服务，否则您及您的负责人应依据法律规定承担因此导致的一切后果。
                                        </b>
                                    </p>
                                    <p>
                                        <b>2.4</b>
                                        【实名认证和/或资质认证】为使您更好地使用绿色慧联的各项服务，保障您的账户安全，绿色慧联有权根据相关法律法规规定或绿色慧联实际经营管理需要，要求您进行实名认证和/或资质认证，如：身份证、机动车驾驶证。
                                        <b>
                                            您理解并同意，按要求完成实名认证和/或资质认证，否则您将有可能无法正常访问/登陆绿色慧联产品或使用服务。
                                        </b>
                                    </p>
                                    <p>
                                        <b>2.5</b>
                                        <b>
                                            您有义务在注册时提供您的真实资料，并保证诸如电子邮件地址、联系电话、联系地址、邮政编码等内容的有效性及安全性。如果因您的个人信息不真实而引起的问题及其产生的后果有您及您的责任人承担，绿色慧联不负任何责任。
                                        </b>
                                    </p>
                                </section>
                                <section>
                                    <h3>三、账户管理</h3>
                                    <p>
                                        <b>3.1</b>
                                        【账户使用】如果您已经取得绿色慧联账户，您可以直接使用您设置或确认的账户名称和账户密码登陆绿色慧联相关产品。由于您的账户关联您的相关信息（包括个人信息、商业信息、交易信息），您的账户仅限您本人使用。
                                        <b>
                                            未经绿色慧联同意，您转让或直接/间接授权第三方使用您的账户或获取您账户项下信息的行为无效。
                                        </b>
                                        如绿色慧联判断您账户的使用可能危及您的账户安全和/或绿色慧联信息安全的，绿色慧联可以拒绝提供相应服务或终止本协议。
                                    </p>
                                    <p>
                                        <b>3.2</b>
                                        【账户保管】您理解并同意，绿色慧联任何时候均不会主动要求您提供您的账户，因此，建议您务必保管好您的账户，保管好您的绿色慧联账户密码和登陆信息。您不得将账号、密码转让或出借他人使用，否则一切后果有您承担，且绿色慧联保留追究您违约责任的权利。
                                        <b>
                                            账户因您主动泄露、保管疏忽或遭受他人攻击、诈骗、黑客等行为导致的损失及后果，均由您自行承担。除绿色慧联存在过错外，您应对您账户项下的所有行为（包括但不限于在线签署各类协议、发布信息、采购服务及披露信息等）负责。
                                        </b>
                                    </p>
                                    <p>
                                        <b>3.3</b>
                                        如果发现任何未经授权使用您账户登录绿色慧联或其他可能导致您账户遭窃、遗失的情况，
                                        <b>
                                            建议您立即通知绿色慧联，并授权绿色慧联将该信息同步给绿色慧联在不同地区拥有子公司和/或关联法律实体。
                                        </b>
                                        您理解绿色慧联对您的任何请求采取行动均需要合理时间，除绿色慧联存在过错外，绿色慧联对因任何未经授权使用您账户登录绿色慧联网站或其他可能导致您账户遭窃、遗失的情况而产生的后果不承担任何责任。
                                    </p>
                                    <p>
                                        <b>3.4</b>
                                        【不活跃账户回收】
                                        <b>
                                            如果您的账户同时符合以下条件，则绿色慧联可回收您的账户，您的账户将不能再登录绿色慧联产品，相应服务同时终止：<br/>
                                            （一）未按照第2.4条约定进行实名认证和/或资质认证的；<br/>
                                            （二）连续六个月未用于登录；<br/>
                                            （三）不存在未到期的有效业务。
                                        </b>
                                    </p>
                                </section>
                                <section>
                                    <h3>四、免责声明</h3>
                                    <p>
                                        <b>4.1</b>
                                        <b>
                                            【服务承诺免责】您理解并同意，绿色慧联公布信息不意味着对服务承诺，具体服务内容以您实际签署的相关协议为准。除本协议或补充协议中明确规定的内容外，绿色慧联、绿色慧联不同地区子公司和/或关联法律实体及其供应商对服务均不作任何具体承诺。
                                        </b>
                                    </p>
                                    <p>
                                        <b>4.2</b>
                                        <b>
                                            【不可抗力免责】绿色慧联依法律规定承担基础保障义务，但无法对由于信息网络设备维护、连接故障，电脑、通讯或其他系统的故障、电力故障、罢工、暴乱、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关的命令或因第三方原因而给您造成的损害结果承担责任。
                                        </b>
                                    </p>
                                    <p>
                                        <b>4.3</b>
                                        <b>
                                            【第三方内容免责】绿色慧联会展示一些不属于绿色慧联的内容，这些内容由发布的实体承担全部责任。绿色慧联可能会审查相关内容，以确定其是否违法或违反了绿色慧联的政策；如果绿色慧联有理由相信该内容违反了绿色慧联的政策或违法，绿色慧联可以将其删除或拒绝展示。不过，这并不意味绿色慧联必然会或有义务审查相关内容。
                                        </b>
                                    </p>
                                    <p>
                                        <b>4.4</b>
                                        <b>
                                            鉴于网络服务的特殊性，绿色慧联无法保证网络服务的及时性、稳定性、准确性。对于因绿色慧联不可控制的原因造成的服务中断或其他缺陷，绿色慧联不承担责任，但将尽量减少因此给您带来的不便。
                                        </b>
                                    </p>
                                    <p>
                                        <b>4.5</b>
                                        <b>
                                            由于绿色慧联需要定期或不定期的对网页端、移动客户端（包括IOS、安卓及已有或未来将新增的任何其他移动客户端）等各类平台媒介或相关设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，绿色慧联无需因此承担任何责任。
                                        </b>
                                    </p>
                                </section>
                                <section>
                                    <h3>五、知识产权</h3>
                                    <p>
                                        <b>5.1</b>
                                        【知识产权归属】除非绿色慧联另行书面声明，绿色慧联向您展示的和/或绿色慧联向您提供服务中的所有产品、技术、软件、程序、数据、文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档及其他信息、内容、资料的所有权利，包括但不限于版权、商标权、专利权、商业秘密及其他所有相关的世界范围内的权利，均归绿色慧联所有。
                                        <b>
                                            未经绿色慧联明确书面授权，任何人不得擅自使用，包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载绿色慧联网站内的任何内容。
                                        </b>
                                        访问绿色慧联和/或使用绿色慧联服务并无法让您获得所访问和/或您所使用的绿色慧联服务中的信息、内容、资料的任何权利。除非您获得相关信息、内容、资料的所有者的许可或通过其他方式获得法律的许可，您不得使用绿色慧联向您展示的和/或绿色慧联向您提供服务内中的任何信息、内容、资料。
                                    </p>
                                    <p>
                                        <b>5.2</b>
                                        【商标使用】绿色慧联相关产品或服务上展示的“绿色慧联”、“XX”、等文字、设计、图形及其组成部分，以及绿色慧联上展示的其他标识、徵记、产品和服务名称，均属于绿色慧联的商标。未经绿色慧联明确书面授权，任何人不得以任何方式在任何国家或区域展示、使用、申请或注册、或以任何其他方式进行处理，也不得在任何国家或区域向他人表明您有权展示、使用、申请或注册、或以任何其他方式进行处理。本协议并未授予您使用、申请或注册绿色慧联上展示的或绿色慧联服务中所用的任何商标的权利。
                                    </p>
                                    <p>
                                        <b>5.3</b>
                                        【侵权处理】绿色慧联非常尊重知识产权。如果您认为绿色慧联向您展示的和/或绿色慧联向您提供服务内中的任何信息、内容、资料可能涉嫌侵犯相关合法权益，可以与绿色慧联联系（客服电话为400-826-2266/0571-82899926），绿色慧联收到后将及时处理。
                                    </p>
                                </section>
                                <section>
                                    <h3>六、信息收集和保护</h3>
                                    <p>
                                        <b>6.1</b>
                                        绿色慧联对于您提供的、自行收集到的、经认证的个人信息将按照本协议隐私规则予以保护、使用或者披露；
                                    </p>
                                    <p>
                                        <b>6.2</b>
                                        <b>
                                            用户注册成功后，即视为允许绿色慧联通过电子邮件或其他方式向用户发送绿色慧联的优惠服务信息。
                                        </b>
                                    </p>
                                    <p>
                                        <b>6.3</b>
                                        <b>
                                            保护用户隐私是绿色慧联的一项基本政策，绿色慧联保证不对外公开或向第三方提供单独用户的注册资料及用户在使用网络服务时存储在绿色慧联的非公开内容，但下列情况除外：<br/>
                                            (1) 事先获得用户的明确授权；<br/>
                                            (2) 根据有关的法律法规要求；<br/>
                                            (3) 按照相关政府主管部门的要求；<br/>
                                            (4) 为维护社会公众的利益；<br/>
                                            (5) 为维护绿色慧联的合法权益；<br/>
                                            (6) 当绿色慧联与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方允诺严格承担与绿色慧联同等的保护用户隐私的责任，则视为您授权绿色慧联将包含您的个人注册资料在内的相关信息仅提供给该等第三方。
                                        </b>
                                    </p>
                                </section>
                                <section>
                                    <h3>七、违约赔偿</h3>
                                    <p>
                                        <b>7.1</b>
                                        <b>
                                            如由于您违反本协议或任何法律、法规或侵害第三方的权利，而引起第三方对绿色慧联相关产品提出的任何形式的索赔、要求、诉讼，绿色慧联有权向您追偿相关损失，包括但不限于本app及绿色慧联的名誉损失、因此支出的法律费用、及向第三方支付的补偿金等。
                                        </b>
                                    </p>
                                    <p>
                                        <b>7.2</b>
                                        <b>
                                            如因绿色慧联违反有关法律、法规或本协议项下的任何条款而给您造成的损失，绿色慧联同意承担由此造成的损害赔偿责任。
                                        </b>
                                    </p>
                                    <p>
                                        <b>7.3</b>
                                        <b>
                                            如由于您因绿色慧联产品上的交易与其他用户产生诉讼，其他用户有权通过司法部门要求绿色慧联提供相关资料。经国家生效法律文书或行政处罚决定确认您存在违法行为，或者绿色慧联有足够事实依据可以认定您存在违法或违反本服务协议的行为的，绿色慧联有权在本产品及网站上公布您的违法、违约行为，并将该内容记入任何与您相关的信用资料和档案。
                                        </b>
                                    </p>
                                </section>
                                <section>
                                    <h3>八、协议变更、终止及其他</h3>
                                    <p>
                                        <b>8.1</b>
                                        <b>
                                            您同意，绿色慧联基于平台服务的安全性，有权中止向您提供部分或全部绿色慧联平台服务，暂时冻结您的账户，待安全问题解决后及时恢复，并对中止、冻结及恢复的事实及时通知。如果网站的安全问题是由于您的违法行为引起，绿色慧联有终止向您提供部分或全部绿色慧联平台服务，永久冻结（注销）您的帐户，并有权向您对损失进行索赔。
                                        </b>
                                    </p>
                                    <p>
                                        <b>8.2</b>
                                        <b>
                                            您有权在结清全部应付费用后向绿色慧联要求注销您的账户，您可随时通过永久性删除移动设备上安装的应用程序，届时，您与绿色慧联基于本协议的合同关系即终止。您的账户被注销后，绿色慧联将删除您的个人信息或做匿名化处理。绿色慧联没有义务为您保留或向您披露您账户中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。
                                        </b>
                                    </p>
                                    <p>
                                        <b>8.3</b>
                                        <b>
                                            您同意，您与绿色慧联的协议关系终止后，绿色慧联仍享有下列权利：<br/>
                                            （1）继续保存您未及时删除的注册信息及您使用绿色慧联平台服务期间发布的所有信息至法律规定的记录保存期满。<br/>
                                            （2）您在使用绿色慧联平台服务期间存在违法行为或违反本协议和/或规则的行为的，绿色慧联仍可依据本协议向您主张权利。
                                        </b>
                                    </p>
                                    <p>
                                        <b>8.4</b>
                                        <b>
                                            您同意，绿色慧联保留随时修改或替换本协议，或者更改、暂停服务及应用程序（包括不限于任何功能、数据库或内容）的权利。届时，我们将通过第九条通知送达条款约定的途径通知您。
                                        </b>
                                    </p>
                                    <p>
                                        <b>8.5</b>
                                        <b>
                                            如果您不同意绿色慧联对本协议相关条款所做的修改，您有权利停止使用绿色慧联服务。如果您继续使用绿色慧联服务，则视为您接受我们对协议相关条款所做的修改，并同意按照修改后的内容履行协议。
                                        </b>
                                    </p>
                                </section>
                                <section>
                                    <h3>九、通知条款</h3>
                                    <p>
                                        <b>9.1</b> 
                                        【有效联系方式】绿色慧联将通过您提供的有效联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。您提供的有效联系方式包括：您准确完整地提供您的真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），以便绿色慧联或其他用户与您联系。
                                        <b>
                                            您了解并同意，您有义务保持您提供联系方式的真实性及有效性。联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。
                                        </b>
                                    </p>
                                    <p>
                                        <b>9.2</b>
                                        【通知送达】绿色慧联通过本协议第9.1约定的有效联系方式向您发出通知。
                                        <b>
                                            其中，以电子的方式发出的书面通知，包括但不限于在绿色慧联公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。
                                        </b>
                                    </p>
                                    <p>
                                        <b>9.3</b>
                                        对于在绿色慧联上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱等联系方式为您在绿色慧联注册、更新时提供的手机号码、电子邮箱联系方式，司法机关向上述联系方式发出法律文书即视为送达。
                                    </p>
                                    <p>
                                        <b>9.4</b>
                                        你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。
                                    </p>
                                </section>
                                <section>
                                    <h3>十、适用法律和管辖</h3>
                                    <p>
                                        <b>10.1</b>
                                        【法律适用】
                                        <b>
                                            本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国法律；如果法律无相关规定的，参照商业惯例和/或行业惯例。
                                        </b>
                                    </p>
                                    <p>
                                        <b>10.2</b>
                                        【管辖条款】
                                        <b>
                                            您因使用绿色慧联服务所产生和/或与服务有关的争议，由绿色慧联与您协商解决；协商不成时，任何一方均可向我公司所在地人民法院提起诉讼。
                                        </b>
                                    </p>
                                </section>
                                <section>
                                    <h3>十一、附加条款</h3>
                                    <p>
                                        <b>11.1</b>
                                        在绿色慧联相关产品的某些部分或页面中可能存在除本协议以外的单独的附加服务条款，当这些条款存在冲突时，页面中的附加条款优先适用。
                                    </p>
                                    <p>
                                        <b>11.2</b>
                                        本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。
                                    </p>
                                </section>
                            </article>
                        </div>
                        <Button type="primary" onClick={()=>{
                            this.props.onQuit(false);
                        }}>确认</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default serviceAgreenmentText;


// WEBPACK FOOTER //
// ./src/invitation/modules/serviceAgreenmentText/index.js